import { CURRENCY } from '@/constants';

/**
 * Formats given number to NOK currency format.
 * @param value Original number
 * @returns Formatted number in KR format
 */
export const formatKr = (value: number | null | undefined): string => {
    if (!Number.isFinite(value)) return '--';

    const formattedValue = value?.toLocaleString('nb-NO', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        useGrouping: true
    });

    return `${formattedValue} ${CURRENCY}`;
};
